export const receiveOutOfOffices = 'OUTOFOFFICE/receiveOutOfOffices';
export const receiveCreateOutOfOffice = 'OUTOFOFFICE/receiveCreateOutOfOffice';
export const receiveUpdateOutOfOffice = 'OUTOFOFFICE/receiveUpdateOutOfOffice';
export const removeOutOfOffice = 'OUTOFOFFICE/removeOutOfOffice';
export const requestData = 'OUTOFOFFICE/requestData';
export const receiveOOOView = 'OUTOFOFFICE/receiveOOOView';
